module.exports = __webpack_public_path__ + "img/api.5253828e.svg";